import React, { Component } from 'react';
import queryString from 'query-string';
import './App.css';

import Header from './components/Header/Header';
import Content from './components/Content/Content';
import Footer from './components/Footer/Footer';

import Translations from './translations';

class App extends Component {
	state = {
		translatedText: Translations.en,
		lang: 'en'
	};

	componentDidMount() {
		const params = queryString.parse(window.location.search);
		const lang = params.lang;
		if(lang && Translations[lang]) {
			this.setState({
				translatedText: Translations[lang],
				lang
			});
		}
	}

	getLangOptions = () => {
		return Object.keys(Translations).map( key => ({
			label: Translations[key].lang,
			value: key
		}));
	};

	render () {
		return (
			<div className="site-wrapper">
				<Header
					langOptions={this.getLangOptions()}
					lang={this.state.lang}
				/>
				<Content translatedText={this.state.translatedText} />
				<Footer translatedText={this.state.translatedText} />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js